import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Vote, Calendar, BarChart3, Building2, FileText } from 'lucide-react';

function Footer() {
  const currentYear = new Date().getFullYear();

  const menuItems = [
    { icon: Users, label: 'நிர்வாகிகள்', path: '/administrators' },
    { icon: Vote, label: 'வாக்காளர் படஂடியலஂ', path: '/vote_booths' },
    { icon: Calendar, label: 'முகஂகிய நிகழஂவுகளஂ', path: '/calendar' },
    { icon: BarChart3, label: 'தேர்தல் முடிவுகள்', path: '/election_results' },
    { icon: Users, label: "பூத் குழு விபரங்கள்", path: "/booth_committee" },
    { icon: FileText, label: "படிவங்கள்", path: "/forms" },
    { icon: Building2, label: "வளர்ச்சித் திட்டங்கள்", path: "/development_projects" }
  ];

  return (
    <footer className="bg-gray-900 text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-orange-400">Quick Links</h3>
            <ul className="space-y-2">
              {menuItems.map((item) => (
                <li key={item.label}>
                  <Link 
                    to={item.path} 
                    className="text-gray-300 hover:text-orange-400 transition-colors flex items-center group"
                  >
                    <item.icon className="w-4 h-4 mr-2 group-hover:scale-110 transition-transform" />
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Person */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-orange-400">அமைபஂபு</h3>
            <div className="flex items-start text-gray-300">
              <div>
                {/* <p>N.விமலஂ B.Sc CS</p> */}
                <p>தகவலஂ தொழிலஂநுடஂபமஂ மறஂறுமஂ தரவு மேலாணஂமை பிரிவு</p>
                {/* <p className="mt-2">Phone: 9566522794</p> */}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} BJP Tamilnadu. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;